<template>
    <div class="wrap">
        <div class="title">
            您的当前位置：{{ $route.query.t1
            }}{{ $route.query.t2 ? "&lt;" + $route.query.t2 : "" }}
        </div>
        <div class="one clearfix">
            <div class="oneLeft">
                <img :src="objOne.cover" alt="加载失败" />
            </div>
            <div class="oneRight">
                <h2>
                    {{ objOne.totalTitle }}
                </h2>
                <p class="score flex-row">
                    <span>评分：</span>
                    <span
                        class="iconfont"
                        v-html="
                            objOne.totalScore == 0
                                ? '&#xe6b6;'
                                : objOne.totalScore >= 1
                                ? '&#xe607;'
                                : '&#xe6b7;'
                        "
                    ></span>
                    <span
                        class="iconfont"
                        v-html="
                            objOne.totalScore <= 1
                                ? '&#xe6b6;'
                                : objOne.totalScore >= 2
                                ? '&#xe607;'
                                : '&#xe6b7;'
                        "
                    ></span>
                    <span
                        class="iconfont"
                        v-html="
                            objOne.totalScore <= 2
                                ? '&#xe6b6;'
                                : objOne.totalScore >= 3
                                ? '&#xe607;'
                                : '&#xe6b7;'
                        "
                    ></span>
                    <span
                        class="iconfont"
                        v-html="
                            objOne.totalScore <= 3
                                ? '&#xe6b6;'
                                : objOne.totalScore >= 4
                                ? '&#xe607;'
                                : '&#xe6b7;'
                        "
                    ></span>
                    <span
                        class="iconfont"
                        v-html="
                            objOne.totalScore <= 4
                                ? '&#xe6b6;'
                                : objOne.totalScore >= 5
                                ? '&#xe607;'
                                : '&#xe6b7;'
                        "
                    ></span>
                    <span class="score-text">{{ objOne.totalScore }}</span>
                </p>
                <p class="tips-box">
                    <span>课程讲师：{{ objOne.teacherName }}</span>
                    <span>课程时长：{{ objOne.totalLength }}</span>
                    <br />
                    <span>学习次数：{{ objOne.popularity }}</span>
                </p>
                <p class="join-btn-box">
                    <span @click="goDetail(objOne.id)" class="join-btn"
                        >我要学习</span
                    >
                    <span
                        @click="getCollect"
                        :class="['join-btn', collect == 1 ? 'collected' : '']"
                        >{{ collect == 1 ? "已收藏" : "收藏" }}</span
                    >
                </p>
            </div>
        </div>
        <!--课程介绍-->
        <div class="two">
            <div class="twoTitle">课程介绍</div>
            <!--公用线-->
            <div class="publicLine">
                <div class="publicChild"></div>
            </div>
            <div class="twoText" v-html="objOne.totalDetails"></div>
        </div>
        <!--讲师介绍-->
        <div class="three">
            <div class="threeTitle">讲师介绍</div>
            <!--公用线-->
            <div class="publicLine">
                <div class="publicChild"></div>
            </div>
            <div class="threeContent clearfix">
                <div class="threeLeft">
                    <img
                        :src="objOne.teacherAvatar"
                        :alt="objOne.teacherName"
                    />
                </div>
                <div class="threeRight">
                    <div class="name">{{ objOne.teacherName }}</div>
                    <div class="rightText">
                        {{ objOne.teacherIntroduction }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "classDetails",
    data() {
        return {
            objOne: [],
            collect: ""
        };
    },
    created() {
        this.getData();
    },
    methods: {
        getData() {
            this.$ajax({
                method: "post",
                url: "homePage/getCoursesSeriesById",
                data: {
                    id: this.$route.query.id,
                    token: this.$store.state.userToken
                },
                success: res => {
                    if (res.code == 200) {
                        this.objOne = res.message;
                        this.collect = res.storeUp;
                    }
                },
                error: res => {}
            });
        },
        goDetail(id) {
            // if (this.$store.state.hasLogin) {
            //     this.$router.push({
            //         name: "zxstudy",
            //         query: {
            //             id: id
            //         }
            //     });
            // } else {
            //     this.$router.push({
            //         name: "login"
            //     });
            // }
            this.$router.push({
                name: "zxstudy",
                query: {
                    id: id
                }
            });
        },
        getCollect() {
            if (this.$store.state.hasLogin) {
                if (this.collect == 1) {
                    // userApi/deleteCollectionCourses
                    this.$ajax({
                        method: "post",
                        url: "userApi/deleteCollectionCourses",
                        data: {
                            coursesSeriesId: this.$route.query.id,
                            token: this.$store.state.userToken
                        },
                        success: res => {
                            if (res.code == 200) {
                                this.collect = 2;
                            }
                        },
                        error: res => {}
                    });
                } else {
                    this.$ajax({
                        method: "post",
                        url: "homePage/collectionCourses",
                        data: {
                            coursesSeriesId: this.$route.query.id,
                            token: this.$store.state.userToken
                        },
                        success: res => {
                            if (res.code == 200) {
                                this.collect = 1;
                            }
                        },
                        error: res => {}
                    });
                }
            } else {
                this.$router.push({
                    name: "login"
                });
            }
        }
    }
};
</script>

<style scoped="scoped" lang="scss">
.wrap {
    width: 1000px;
    margin: 0 auto;
}
.title {
    color: #999;
    padding: 5px 0;
}
.one {
    overflow: hidden;
}

.oneLeft {
    width: 390px;
    height: 270px;
    float: left;
    box-sizing: border-box;
    border: 1px solid #ddd;
    overflow: hidden;
    img {
        width: 100%;
        height: 100%;
    }
}

.oneRight {
    width: 580px;
    height: 270px;
    float: right;
    box-sizing: border-box;
    position: relative;
    color: #333333;
    h2 {
        font-size: 26px;
        line-height: 30px;
    }
    .score {
        align-items: center;
        .iconfont {
            font-size: 24px;
            line-height: 24px;
            color: #6ac0e8;
        }
        .score-text {
            padding-left: 10px;
            font-weight: bold;
            color: #6ac0e8;
        }
    }
    .tips-box {
        margin-top: 40px;
        font-size: 16px;
        span {
            padding-right: 20px;
            line-height: 30px;
        }
        margin-bottom: 5px;
    }
    .address {
        margin-bottom: 5px;
    }
    .join-btn-box {
        position: absolute;
        bottom: 0;
        left: 0;
    }
    .join-btn {
        display: inline-block;
        text-align: center;
        line-height: 40px;
        width: 178px;
        height: 40px;
        color: #fff;
        font-size: 16px;
        background-color: #6ac0e8;
        border-radius: 4px;
        margin-right: 20px;
        cursor: pointer;
        transition: all ease 0.3s;
    }
    .join-btn:hover {
        color: #000;
    }
    .collected {
        background-color: #999;
    }
}

.oneTitle {
    font-size: 25px;
    padding: 15px 0;
}

.score {
    margin: 10px 0;
}

.teachOne,
.teachTwo {
    margin: 10px 0;
}

.oneBtn,
.twoBtn {
    display: inline-block;
    width: 150px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    margin-top: 20px;
}

.oneBtn {
    background-color: #6ac0e8;
    color: white;
}

.twoBtn {
    box-sizing: border-box;
    border: 1px solid black;
}

.publicLine {
    width: 100%;
    border-bottom: 2px solid gainsboro;
    position: relative;
}

.publicChild {
    width: 70px;
    border-bottom: 2px solid #6ac0e8;
    position: absolute;
    top: 0;
    left: 0;
}

.twoTitle,
.threeTitle {
    padding: 10px 0;
}

.twoText,
.threeContent {
    padding: 10px 0;
    min-height: 150px;
    overflow: hidden;
}

.threeLeft {
    width: 175px;
    min-height: 155px;
    float: left;
    border: 1px solid #ddd;
    overflow: hidden;
    img {
        width: 100%;
        min-height: 100%;
    }
}

.threeRight {
    width: 810px;
    height: 155px;
    float: right;
    padding: 10px;
    box-sizing: border-box;
}

.name {
    font-size: 18px;
    font-weight: 550;
}
</style>



// WEBPACK FOOTER //
// src/components/zxkc/classDetails.vue